module.exports = __webpack_public_path__ + "img/upload.2000866b.svg";